import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
// @ts-ignore
import DatePagination from 'components/DatePagination';
// @ts-ignore
import { selectCurrentNumberOfDays } from 'services/currentNumberOfDays/selectors';

interface ConnectedProps {
    currentNumberOfDays?: ReturnType<typeof selectCurrentNumberOfDays>;
}

type Props = ConnectedProps;

export class EventsTimelineDatePaginationComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { currentNumberOfDays } = this.props;
        return <DatePagination numberOfDays={currentNumberOfDays} />;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    currentNumberOfDays: selectCurrentNumberOfDays
});

export default connect(mapStateToProps)(EventsTimelineDatePaginationComponent);
